import home from "./home.jpg"
import logo_white from "./logo_white.png"
import whatsappIcon from "./whatsappIcon.png"
import soft from "./soft.jpg"
import customweb from "./customweb.jpg"
import business from "./business.jpg"
import uiux from "./uiux.jpg"
import digital from "./digital.jpg"
import devops from "./devops.jpg"
import customslide from "./customslide.jpg"
import uiuxslide from "./uiuxslide.jpg"
import digitalslide from "./digitalslide.jpg"
import devopsslide from "./devopsslide.jpg"
import about from "./about.png"
import devopsheader from "./devopsheader.png"
import businessheader from "./businessheader.png"
import customheader from "./customheader.jpg"
import digitalheader from "./digitalheader.jpg"


import businessslide from "./businessslide.jpg"
import uiuxheader from "./uiuxheader.jpg"
import industryheader from "./industryheader.jpg"
import seikurallogo from "./seikurallogo.png"

const img = {
    home,
    logo_white,
    whatsappIcon,
    soft,
    customweb,
    business,
    uiux,
    digital,
    devops,
    customslide,
    uiuxslide,
    digitalslide,
    devopsslide,
    businessslide,
    about,
    customheader,
    businessheader,
    devopsheader, digitalheader, uiuxheader, industryheader, seikurallogo


}
export default img
